import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments';
import { Feedback } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private httpClient = inject(HttpClient);

  createEmailSupport(feedback: Feedback): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + '/support/email', feedback);
  }

  createHelpSupport(feedback: Feedback): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + '/support/help', feedback);
  }
}
